import config from 'config';
import {buildPath} from 'utils/commonUtils';

// Set of helpers for simplifying Helmet titleTemplate creation

export function makeTitleTemplate(middle) {
  const titleTemplate = ["%s"];

  if (middle) {
    titleTemplate.push(middle);
  }

  titleTemplate.push(config.pageTitle.mainSuffix);

  return titleTemplate.join(" - ");
}

export const titleTemplate = {
  get plain() {return makeTitleTemplate()}
};

const midfixList = config.pageTitle.midfix;
Object.keys(midfixList).forEach(sport => {
  Object.defineProperty(titleTemplate, sport, {get: () => makeTitleTemplate(midfixList[sport])})
});


export function canonicalLink(routeArray, paramList = {}) {
  let path = buildPath(routeArray);
  Object.keys(paramList).forEach(name => {
    path = path.replace(new RegExp(`:${name}(\\b)`, 'g'), paramList[name]);
  });

  return canonicalRel(path);
}

export function canonicalRel(path) {
  return {link: [{
    rel: "canonical",
    href: `${config.canonicalBase}${path}`
  }]};
}

export function metaDescription(content) {
  return {meta: [{
    name: "description",
    content
  }]};
}



// WEBPACK FOOTER //
// ./utils/seoUtils.js